/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../locale-data/index.js (ignored)
// module id = 668
// module chunks = 0